import { types } from 'mobx-state-tree';
import Specific from './Specific';
import Picture from './Picture';
import Label from './Label';
import { Cell } from '../../models/ListingsPage';
import { PricingStrategy } from './PricingStrategy';

export const SingleListingsItemData = types
  .model('SingleListingsItemData', {
    id: types.maybe(types.string),
    accountId: types.maybe(types.string),
    destinationItemId: types.maybe(types.string),
    title: types.maybe(types.string),
    destinationMarketplaceId: types.maybe(types.string),
    listDate: types.maybe(types.string),
    startDate: types.maybe(types.string),
    endDate: types.maybe(types.string),
    sourceMarketplaceId: types.maybe(types.string),
    sourceItemCode: types.maybe(types.string),
    initialSourceItemCode: types.maybe(types.string),
    sourceItemCodeChanged: types.maybe(types.boolean),
    sourceItemCodeType: types.maybe(types.string),
    sellerAccountId: types.maybe(types.string),
    sellerAccountName: types.maybe(types.string),
    status: types.maybe(types.string),
    quantity: types.maybe(types.union(types.number, types.string)),
    monitoringStatus: types.maybe(types.string),
    businessPolicySetId: types.maybe(types.string),
    templateId: types.maybe(types.string),
    multiVariation: types.maybe(types.optional(types.boolean, true)),
    uuid: types.maybe(types.string),
    ean: types.maybe(types.string),
    isbn: types.maybe(types.string),
    upc: types.maybe(types.string),
    brand: types.maybe(types.string),
    mpn: types.maybe(types.string),
    description: types.maybe(types.string),
    location: types.maybe(types.string),
    categoryId: types.maybe(types.string),
    categoryName: types.maybe(types.string),
    productReferenceId: types.maybe(types.string),
    competitorCount: types.maybe(types.number),
    watchCount: types.maybe(types.number),
    hitCount: types.maybe(types.number),
    discoveryId: types.maybe(types.string),
    discoveryDate: types.maybe(types.string),
    discoveryListedItemsCount: types.maybe(types.number),
    quantitySold: types.maybe(types.number),
    lastSaleDate: types.maybe(types.string),
    outOfStockDate: types.maybe(types.string),
    sourceItemUrl: types.maybe(types.string),
    destinationItemUrl: types.maybe(types.string),
    condition: types.maybe(types.string),
    timeLeftDays: types.maybe(types.number),
    withoutSalesDays: types.maybe(types.number),
    outOfStockDays: types.maybe(types.number),
    strategyUp: types.maybe(types.number),
    strategyDown: types.maybe(types.number),
    pictures: types.optional(types.array(Picture), []),
    labels: types.optional(types.array(Label), []),
    specifics: types.optional(types.array(Specific), []),
    removedLabels: types.optional(types.array(Cell), []),
    addedLabels: types.optional(types.array(Cell), []),
    pricingStrategy: types.maybe(PricingStrategy),
    variations: types.optional(types.array(types.frozen), []), // we don't use the data at the moment
    isMarketplace: types.optional(types.boolean,false),
  })
  .actions(self => ({
    addSpecific(newSpec){
      const newSpecific = Specific.create(newSpec);
      self.specifics.push(newSpecific)
    },
    addLabel(value) {
      const newLabel = { id: Date.now().toString(), text: value };
      self.labels.push(newLabel);
      self.addedLabels.push({ value, op: 'add', path: '/label' });
    },
    removeLabel(labelId) {
      self.labels = self.labels.filter(({ id }) => id !== labelId);
      self.removedLabels.push({ value: labelId, op: 'remove', path: '/label' });
    },
    setTitle(value) {
      self.title = value;
    },
    setAsin(value) {
      self.sourceItemCode = value;
    },
    setStatus(value) {
      self.status = value;
    },
    setMonitoringStatus(value) {
      self.monitoringStatus = value;
    },
    setDestinationPrice(value) {
      self.pricingStrategy.salePrice = value ? parseFloat(value) : '';
    },
    setBreakEven(value) {
      self.pricingStrategy.strategyBreakEven = value ? parseInt(value, 10) : '';
    },
    setTemplate(value) {
      self.templateId = value;
    },
    setQuantity(value) {
      self.quantity = value ? parseInt(value, 10) : '';
    },
    setStrategyPercents(value) {
      self.pricingStrategy.profitType = value === true ? 1 : 2;
    },
    setProfit(value) {
      let valueToSave;
      if (typeof value === 'string') {
        valueToSave = value ? parseFloat(value, 10) : '';
      } else {
        valueToSave = value || '';
      }
      if (!self.pricingStrategy.strategyInPercents) {
        self.setUnitProfit(valueToSave);
      } else {
        self.setPercentProfit(valueToSave);
      }
    },
    setUnitProfit(val) {
      self.pricingStrategy.profit = val;
    },
    setPercentProfit(val) {
      self.pricingStrategy.profitInPercents = val;
    }
  }));
